import { FC } from 'react';
import { makeStyles } from 'tss-react/mui';
import { Theme } from '@mui/material';
import SbomStore from '../stores/sbom-store';
import { useSnapshot } from 'valtio';
import SearchLibraryInput from '../components/SearchLibraryInput';
import { onSearchChange } from '../actions/sbom-libraries-actions';
import SbomMenuDownload from '../components/sbomMenuDownload';
import SbomFiltersStore from '../stores/sbom-filters-store';

const SbomControlContainer: FC<
  React.PropsWithChildren<SbomControlContainerProps>
> = props => {
  const { classes } = useStyles();
  const { searchValue, total, loading } = useSnapshot(SbomStore);
  const { totalFilters, loadingFilters } = useSnapshot(SbomFiltersStore);

  return (
    <div className={classes.container}>
      <SearchLibraryInput searchValue={searchValue} onSearch={onSearchChange} />
      <SbomMenuDownload
        csvDownloadDisabledSearch={total === 0}
        csvDownloadDisabledFilter={totalFilters === 0 && searchValue === ''}
        isLoadingFilters={loadingFilters.isPending()}
        isLoadingSbom={loading.isPending()}
      />
    </div>
  );
};

const useStyles = makeStyles()((theme: Theme) => ({
  container: {
    marginBlock: theme.spacing(1),
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
  },
}));

export interface SbomControlContainerProps {}

export default SbomControlContainer;
